import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';

import {EnumNames, SterbefallStatus} from '../../model/enums';
import {Sterbefall} from '../../model/sterbefall';
import {SterbefallPage} from '../sterbefall/sterbefall';

import { SterbefallProvider } from '../../providers/sterbefall.provider';
import { GuiProvider } from '../../providers/gui.provider';


@Component({
	templateUrl: 'sterbefaelle.html'
})
export class SterbefaellePage {
	sterbefaelle : Sterbefall[];

	constructor(
		public nav: NavController,
		public sterbefallProvider: SterbefallProvider,
		public guiProvider : GuiProvider) {
	}

	ionViewWillEnter() {
		this.sterbefaelle = this.sterbefallProvider.getSterbefaelle();
	}

	/**
	 * Öffnet die Formularansicht für die Eingabe eines neuen Sterbefalls.
	 */
	newSterbefall() {
		if (this.sterbefallProvider.sterbefaelle.length >= this.sterbefallProvider.maxSterbefaelle)
			this.guiProvider.showAlertYesOrNo("Achtung", "Die maximale Anzahl an Sterbefällen ist erreicht. Bitte löschen Sie zunächst alte Sterbefälle.\n" +
				"Sollen automatisch die ältesten 50 bereits übermittelten Sterbefälle gelöscht werden?", () => {
				this.sterbefallProvider.cleanUp(50);
				this.sterbefaelle = this.sterbefallProvider.getSterbefaelle();
			}, () => {});
		else
			this.openSterbefall(null);
	}

	/**
	 * Öffnet den gegebenen Sterbefall in der Formularansicht.
	 */
	openSterbefall(sterbefall) {
		this.nav.push(SterbefallPage, { sterbefall: sterbefall });
	}

	/**
	 * Löscht nach Rückfrage den gegebenen Sterbefall.
	 */
	deleteSterbefall(sterbefall) {
		this.guiProvider.showAlertYesOrNo("Löschen", "Diesen Sterbefall endgültig löschen?",
			() => { this.sterbefaelle = this.sterbefallProvider.deleteSterbefall(sterbefall); }, () => {});
	}

	//helper
	getStatusName(s: SterbefallStatus) : string { return EnumNames.getSterbefallStatusName(s); }
}



// WEBPACK FOOTER //
// ./src/pages/sterbefaelle/sterbefaelle.ts